import type { TableView } from 'owa-mail-list-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getViewFilterForTable } from 'owa-mail-list-store';

export function shouldUseCustomHighPriorityView(tableView: TableView | undefined): boolean {
    return !!(
        isFeatureEnabled('tri-prioritize-on-demand') &&
        getViewFilterForTable(tableView) === 'CopilotHighPriority'
    );
}
